import demoVideo from "../Assets/images/demo.mp4";
const Hero = () => {
  return (
    <section className="px-4 py-4">
      <div className="max-w-[900px] mx-auto sm:text-center">
        {/* Title */}
        <h1 className="text-4xl font-bold leading-tight md:text-5xl">
          Take Back Control of Your Wallet.
        </h1>

        {/* Description */}
        <p className="mt-2 text-gray-500 text-md text-muted md:text-lg">
          When using dapps like Uniswap or OpenSea you have to grant them
          permission to spend your tokens and NFTs. This is called a token
          approval. If you don't revoke these approvals, the dapp can spend your
          tokens forever. Take back control by revoking your approvals.
        </p>

        {/* Video Section */}
        <div className="mt-4">
          <div className="overflow-hidden shadow-lg rounded-xl">
            <video controls className="w-full">
              <source src={demoVideo} type="video/mp4" />
            </video>
          </div>
        </div>
        {/* Button */}
        <div className="flex justify-center mt-8">
          <button className="px-8 py-4 text-sm font-bold text-white transition-transform bg-black rounded-lg shadow-lg md:text-lg hover:scale-105">
            Get Started
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
